import { render, staticRenderFns } from "./Lotto.vue?vue&type=template&id=1fedd6a6&scoped=true&"
import script from "./Lotto.vue?vue&type=script&lang=js&"
export * from "./Lotto.vue?vue&type=script&lang=js&"
import style0 from "./Lotto.vue?vue&type=style&index=0&id=1fedd6a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fedd6a6",
  null
  
)

export default component.exports